import { defaultTheme } from "./defaultTheme";

/**
 * Merge white-label theme tokens over the default theme.
 * @param {object} [overrides]
 * @returns {object}
 */
export function createTheme(overrides) {
  overrides = overrides || {};
  return {
    colors: Object.assign({}, defaultTheme.colors, overrides.colors || {}),
    typography: Object.assign(
      {},
      defaultTheme.typography,
      overrides.typography || {}
    ),
    controls: Object.assign({}, defaultTheme.controls, overrides.controls || {}),
    branding: Object.assign({}, defaultTheme.branding, overrides.branding || {}),
  };
}

export default createTheme;
